import { render, staticRenderFns } from "./AdminSettingIpRestriction.vue?vue&type=template&id=45705ea7&scoped=true&"
import script from "./AdminSettingIpRestriction.vue?vue&type=script&lang=js&"
export * from "./AdminSettingIpRestriction.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingIpRestriction.vue?vue&type=style&index=0&id=45705ea7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45705ea7",
  null
  
)

export default component.exports